import PropTypes from 'prop-types';

export const FILTER_LOGIC = {
	OR: 'OR',
	AND: 'AND',
	NOT: 'NOT'
};

export const SLIDER_OPERATORS = {
	LT: {
		id: 'LT',
		siftOperator: '$lt',
		symbol: '\u003C'
	},
	LTE: {
		id: 'LTE',
		siftOperator: '$lte',
		symbol: '\u2264'
	},
	GT: {
		id: 'GT',
		siftOperator: '$gt',
		symbol: '\u003E'
	},
	GTE: {
		id: 'GTE',
		siftOperator: '$gte',
		symbol: '\u2265'
	}
};

/**
 * CBGS - checkbox group single - Group of checkboxes representing multiple string values from one column. 'OR' logic is used.
 * CBGM - checkbox group multiple - Group of checkboxes representing boolean values of multiple columns. 'AND' logic is used.
 * CB - checkbox - Checkbox with specific label and True/False value.
 * TI - text input - Useful as a number input with one-side limit. Limits '<', '>', '>=', '<=' are necessary.
 * RB - radio buttons - Useful for small number of values (2-3), where only one value can be selected at time.
 * RBB - radio buttons boolean - Two radio buttons representing True/False values. This filter can be used as an alternative to CBB.
 * SM - select menu - Useful when selecting one value from large set of values. Similar to radio buttons.
 * SMM - select menu multiple - Combination of CB and SM filters that allows to select multiple values in select menu.
 * RF - range filter - Slider for selecting products from specified range [min, max].
 */
export const DATA_TYPES = {
	/* TODO: align with API */
	// CHECKBOX: 'CB',
	// //CHECKBOX: 'RBB',
	// CHECKBOX_GROUP_SINGLE_COLUMN: 'CBGS',
	// //CHECKBOX_GROUP_SINGLE_COLUMN: 'CB',
	// //CHECKBOX_GROUP_MULTI_COLUMNS: 'CBGM',
	// do not use RBB | RB will be only used as exclusive ( ?optionaly required)
	// RADIO_BUTTONS: 'RB',
	// RADIO_BUTTONS_BOOLEAN: 'RBB',
	// //SLIDER: 'RF',
	// //SELECT: 'SM',
	// //SELECT_MULTIPLE_SINGLE_COLUMN: 'SMMSC',
	// //SELECT_MULTIPLE_MULTI_COLUMNS: 'SMMMC',
	// //INPUT: 'TI',
	BOOLEAN: 'B', // checkbox
	NUMERIC: 'N', // slider (single/range), input
	STRING: 'S' // checkbox group, select (single/multiple), chips (single/multiple, max 3-4 values)
};

export const FILTER_TYPES = {
	CHECKBOX: 'CB',
	SELECTION_GROUP: 'SG',
	SELECTION_GROUP_MULTIPLE: 'SGM',
	CHIPS: 'CP',
	CHIPS_MULTIPLE: 'CPM',
	INPUT: 'IN',
	SELECT: 'SE',
	SELECT_MULTIPLE: 'SEM',
	SLIDER: 'SL',
	RANGE_SLIDER: 'RSL'
};

export const FILTER_SHAPE = PropTypes.shape({
	cid: PropTypes.string.isRequired,
	conditional: PropTypes.bool,
	disabled: PropTypes.bool,
	label: PropTypes.string.isRequired,
	logic: PropTypes.oneOf(Object.values(FILTER_LOGIC)),
	longLabel: PropTypes.string,
	multiSelect: PropTypes.bool,
	order: PropTypes.number,
	type: PropTypes.oneOf(Object.values(DATA_TYPES)),
	unit: PropTypes.string,
	values: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.bool, PropTypes.object]))
		.isRequired
});
